import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    // 錯誤網址會導至登入面

    path: "*",
    redirect: "/Landing",
  },

  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/logout.vue"),
  },

  {
    path: "/Landing",
    name: "Landing",
    component: () => import("../views/Landing.vue"),
  },

  {
    path: "/",
    name: "cn",
    redirect: "/Landing",

    component: () => import("@/views/cn/cnLayout.vue"),

    children: [
      {
        path: "/",
        name: "index",
        component: () => import("../views/cn/index.vue"),

        meta: {
          title: "展覽列表 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      // {
      //   path: '/SignalRCenter',
      //   name: 'SignalRCenter',
      //   component: () => import('../views/cn/SignalRCenter.vue'),
      //   meta: {
      //     title: '客服通訊中心 - 展昭參展商管理系統',
      //     requiresAuth: true,
      //   },
      // },

      {
        path: "/directory",
        name: "directory",
        component: () => import("../views/cn/directory.vue"),

        meta: {
          title: "會刊登錄 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/directory2",
        name: "directory2",
        component: () => import("../views/cn/directory2.vue"),

        meta: {
          title: "會刊登錄 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

  

      {
        path: "/download",
        name: "download",
        component: () => import("../views/cn/download.vue"),
        meta: {
          title: "下載專區 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },
      {
        path: "home",
        name: "home",
        component: () => import("../views/cn/home.vue"),
        meta: {
          title: "首頁 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/inquiry",
        name: "inquiry",
        component: () => import("../views/cn/inquiry.vue"),
        meta: {
          title: "詢問記錄 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/inquiryEditor",
        name: "inquiryEditor",
        component: () => import("../views/cn/inquiryEditor.vue"),
        meta: {
          title: "詢問記錄 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/invite",
        name: "invite",
        component: () => import("../views/cn/invite.vue"),
        meta: {
          title: "電子邀請函 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/invitePaper",
        name: "invitePaper",
        component: () => import("../views/cn/invitePaper.vue"),
        meta: {
          title: "紙本邀請函 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/invitePaper2",
        name: "invitePaper2",
        component: () => import("../views/cn/invitePaper2.vue"),
        meta: {
          title: "紙本邀請函 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/invitePaperApply",
        name: "invitePaperApply",
        component: () => import("../views/cn/invitePaperApply.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "/inviteProxy",
        name: "inviteProxy",
        component: () => import("../views/cn/inviteProxy/inviteProxy.vue"),
        meta: {
          title: "代理申請 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/inviteProxyApply",
        name: "inviteProxyApply",
        component: () => import("../views/cn/inviteProxy/inviteProxyApply.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "/inviteProxyList",
        name: "inviteProxyList",
        component: () => import("../views/cn/inviteProxy/inviteProxyList.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "/inviteProxyReg",
        name: "inviteProxyReg",
        component: () => import("../views/cn/inviteProxy/inviteProxyReg.vue"),
        meta: {
          title: "代理申請 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/inviteProxyRegApply",
        name: "inviteProxyRegApply",
        component: () =>
          import("../views/cn/inviteProxy/inviteProxyRegApply.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "/inviteProxyRegList",
        name: "inviteProxyRegList",
        component: () =>
          import("../views/cn/inviteProxy/inviteProxyRegList.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "/inviteReg",
        name: "inviteReg",
        component: () => import("../views/cn/inviteReg.vue"),
        meta: {
          title: "電子邀請函 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },
      {
        path: "/inviteTel",
        name: "inviteTel",
        component: () => import("../views/cn/inviteTel.vue"),
        meta: {
          title: "電話申請 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },
      {
        path: "/inviteVIP",
        name: "inviteVIP",
        component: () => import("../views/cn/inviteVIP/inviteVIP.vue"),
        meta: {
          title: "VIP名單登錄 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/inviteVIPList",
        name: "inviteVIPList",
        component: () => import("../views/cn/inviteVIP/inviteVIPList.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "/inviteVIPApply",
        name: "inviteVIPApply",
        component: () => import("../views/cn/inviteVIP/inviteVIPApply.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "/onlineExpo",
        name: "onlineExpo",
        component: () => import("../views/cn/onlineExpo/onlineExpo.vue"),
        meta: {
          title: "線上展覽設定 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/onlineExpoBanner1",
        name: "onlineExpoBanner1",
        component: () => import("../views/cn/onlineExpo/onlineExpoBanner1.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "/onlineExpoBanner2",
        name: "onlineExpoBanner2",
        component: () => import("../views/cn/onlineExpo/onlineExpoBanner2.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "/onlineExpoBanner3",
        name: "onlineExpoBanner3",
        component: () => import("../views/cn/onlineExpo/onlineExpoBanner3.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "/onlineExpoBanner4",
        name: "onlineExpoBanner4",
        component: () => import("../views/cn/onlineExpo/onlineExpoBanner4.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "/onlineExpoBooth",
        name: "onlineExpoBooth",
        component: () => import("../views/cn/onlineExpo/onlineExpoBooth.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "/onlineExpoCardInfo",
        name: "onlineExpoCardInfo",
        component: () =>
          import("../views/cn/onlineExpo/onlineExpoCardInfo.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "/onlineExpoVideoList",
        name: "onlineExpoVideoList",
        component: () =>
          import("../views/cn/onlineExpo/onlineExpoVideoList.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "/onlineVideoAdd",
        name: "onlineVideoAdd",
        component: () => import("../views/cn/onlineExpo/onlineVideoAdd.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("../views/cn/profile.vue"),
        meta: {
          title: "基本資料 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/certificationApply",
        name: "certificationApply",
        component: () => import("../views/cn/certificationApply.vue"),
        meta: {
          title: "申請參展證明 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },
      {
        path: "/upgrade",
        name: "upgrade",
        component: () => import("../views/cn/upgrade.vue"),
        meta: {
          title: "加值服務方案 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },
      {
        path: "/upgradeEdm",
        name: "upgradeEdm",
        component: () => import("../views/cn/upgradeEdm.vue"),
        meta: {
          title: "展前快訊EDM - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },
      {
        path: "/upgradeGet",
        name: "upgradeGet",
        component: () => import("../views/cn/upgradeGet/upgradeGet.vue"),
        meta: {
          title: "買主資料即時GET - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/chanchaoApp",
        name: "chanchaoApp",
        component: () => import("../views/cn/chanchaoApp.vue"),
        meta: {
          title: "展昭展覽APP - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/upgradeGetCard",
        name: "upgradeGetCard",
        component: () => import("../views/cn/upgradeGet/upgradeGetCard.vue"),
        meta: {},
      },

      {
        path: "/upgradeGetCardInfo",
        name: "upgradeGetCardInfo",
        component: () =>
          import("../views/cn/upgradeGet/upgradeGetCardInfo.vue"),
        meta: {},
      },

      {
        path: "/upgradeGetList",
        name: "upgradeGetList",
        component: () => import("../views/cn/upgradeGet/upgradeGetList.vue"),
        meta: {},
      },

      {
        path: "/news",
        name: "news",
        component: () => import("../views/cn/News/news.vue"),
        meta: {
          title: "新聞稿 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/newsAdd",
        name: "newsAdd",
        component: () => import("../views/cn/News/newsAdd.vue"),
        meta: {
          title: "新聞稿 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/newsEdit",
        name: "newsEdit",
        component: () => import("../views/cn/News/newsEdit.vue"),
        meta: {
          title: "新聞稿 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },
      {
        path: "/Boothevent",
        name: "Boothevent",
        component: () => import("../views/cn/Boothevent/Boothevent.vue"),
        meta: {
          title: "攤位活動 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },
      {
        path: "/Boothevent",
        name: "Boothevent",
        component: () => import("../views/cn/Boothevent/Boothevent.vue"),
        meta: {
          title: "攤位活動 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/BootheventAdd",
        name: "BootheventAdd",
        component: () => import("../views/cn/Boothevent/BootheventAdd.vue"),
        meta: {
          title: "新增攤位活動 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/BootheventEdit",
        name: "BootheventEdit",
        component: () => import("../views/cn/Boothevent/BootheventEdit.vue"),
        meta: {
          title: "編輯攤位活動 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/product",
        name: "product",
        component: () => import("../views/cn/Product/product.vue"),
        meta: {
          title: "參展產品 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/productAdd",
        name: "productAdd",
        component: () => import("../views/cn/Product/productAdd.vue"),
        meta: {
          title: "參展產品 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/productEdit",
        name: "productEdit",
        component: () => import("../views/cn/Product/productEdit.vue"),
        meta: {
          title: "參展產品 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/productHistoryExh",
        name: "productHistoryExh",
        component: () => import("../views/cn/Product/productHistoryExh.vue"),
        meta: {
          title: "歷屆參展列表 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/productHistoryPro",
        name: "productHistoryPro",
        component: () => import("../views/cn/Product/productHistoryPro.vue"),
        meta: {
          title: "選擇產品 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/campaign",
        name: "campaign",
        component: () => import("../views/cn/campaign/campaign.vue"),
        meta: {
          title: "官方行銷活動 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/campaignDetail",
        name: "campaignDetail",
        component: () => import("../views/cn/campaign/campaignDetail.vue"),
        meta: {
          title: "行銷活動資訊 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/campaignGiveawayAdd",
        name: "campaignGiveawayAdd",
        component: () => import("../views/cn/campaign/campaignGiveawayAdd.vue"),
        meta: {
          title: "新增贈品贊助活動 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/campaignGiveawayEdit",
        name: "campaignGiveawayEdit",
        component: () =>
          import("../views/cn/campaign/campaignGiveawayEdit.vue"),
        meta: {
          title: "編輯贈品贊助活動 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "video",
        name: "video",
        component: () => import("../views/cn/Video/video.vue"),
        meta: {
          title: "參展商影音 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/videoAdd",
        name: "videoAdd",
        component: () => import("../views/cn/Video/videoAdd.vue"),
        meta: {
          title: "參展商影音 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/videoEdit",
        name: "videoEdit",
        component: () => import("../views/cn/Video/videoEdit.vue"),
        meta: {
          title: "參展商影音 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/promotion",
        name: "promotion",
        component: () => import("../views/cn/Promotion/promotion.vue"),
        meta: {
          title: "產品推廣活動 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/promotionAdd",
        name: "promotionAdd",
        component: () => import("../views/cn/Promotion/promotionAdd.vue"),
        meta: {
          title: "建立推廣產品介紹 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/promotionSelectPro",
        name: "promotionSelectPro",
        component: () => import("../views/cn/Promotion/promotionSelectPro.vue"),
        meta: {
          title: "選擇推廣產品 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "/promotionEdit",
        name: "promotionEdit",
        component: () => import("../views/cn/Promotion/promotionEdit.vue"),
        meta: {
          title: "編輯推廣產品 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "fascia",
        name: "fascia",
        component: () => import("../views/cn/fascia.vue"),
        meta: {
          title: "招牌登錄 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "Badge",
        name: "Badge",
        component: () => import("../views/cn/Badge/Badge.vue"),
        meta: {
          title: "參展證申請 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },

      {
        path: "BadgeAdd",
        name: "BadgeAdd",
        component: () => import("../views/cn/Badge/BadgeAdd.vue"),
        meta: {
          title: "新增參展證 - 展昭參展商管理系統",
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: "/en",
    name: "en",
    redirect: "/en/Landing",

    component: () => import("@/views/en/enLayout.vue"),

    children: [
      {
        path: "/",
        name: "index_en",
        component: () => import("@/views/en/index.vue"),
        meta: {
          title: `Chan Chao Exhibitor's Online Service System`,
          requiresAuth: true,
        },
      },

      {
        path: "Landing",
        name: "Landing_en",
        component: () => import("@/views/en/Landing.vue"),
        meta: {
          title: `Directory Entry - Chan Chao Exhibitor's Online Service System`,
        },
      },

      {
        path: "directory",
        name: "directory_en",
        component: () => import("@/views/en/directory.vue"),
        meta: {
          title: "Directory Entry - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "directory2",
        name: "directory_en",
        component: () => import("@/views/en/directory2.vue"),
        meta: {
          title: "Directory Entry - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },
      {
        path: "download",
        name: "download_en",
        component: () => import("@/views/en/download.vue"),
        meta: {
          title: "Download - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },
      {
        path: "home",
        name: "home_en",
        component: () => import("@/views/en/home.vue"),
        meta: {
          title: `Home - Chan Chao Exhibitor's Online Service System`,
          requiresAuth: true,
        },
      },

      {
        path: "inquiry",
        name: "inquiry_en",
        component: () => import("@/views/en/inquiry.vue"),
        meta: {
          title: "Inquiries - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "inquiryEditor",
        name: "inquiryEditor_en",
        component: () => import("../views/en/inquiryEditor.vue"),
        meta: {
          title: "Inquiries - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },
      {
        path: "invite",
        name: "invite_en",
        component: () => import("@/views/en/invite.vue"),
        meta: {
          title: "Invitation EDM - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },
      {
        path: "inviteProxy",
        name: "inviteProxy_en",
        component: () => import("@/views/en/inviteProxy/inviteProxy.vue"),
        meta: {
          title:
            "Client Registration - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "inviteProxyApply",
        name: "inviteProxyApply_en",
        component: () => import("../views/en/inviteProxy/inviteProxyApply.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "inviteProxyList",
        name: "inviteProxyList_en",
        component: () => import("../views/en/inviteProxy/inviteProxyList.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "inviteProxyReg",
        name: "inviteProxyReg_en",
        component: () => import("@/views/en/inviteProxy/inviteProxyReg.vue"),
        meta: {
          title:
            "Client Registration - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "inviteProxyRegApply",
        name: "inviteProxyRegApply_en",
        component: () =>
          import("../views/en/inviteProxy/inviteProxyRegApply.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "inviteProxyRegList",
        name: "inviteProxyRegList_en",
        component: () =>
          import("../views/en/inviteProxy/inviteProxyRegList.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "inviteReg",
        name: "inviteReg_en",
        component: () => import("@/views/en/inviteReg.vue"),
        meta: {
          title: "Invitation EDM - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },
      {
        path: "inviteTel",
        name: "inviteTel_en",
        component: () => import("@/views/en/inviteTel.vue"),
        meta: {
          title: `Phone Application - Chan Chao Exhibitor Online Service System`,
          requiresAuth: true,
        },
      },
      {
        path: "inviteVIP",
        name: "inviteVIP_en",
        component: () => import("@/views/en/inviteVIP/inviteVIP.vue"),
        meta: {
          title: "VIP Registration - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "inviteVIPList",
        name: "inviteVIPList_en",
        component: () => import("../views/en/inviteVIP/inviteVIPList.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "inviteVIPApply",
        name: "inviteVIPApply_en",
        component: () => import("../views/en/inviteVIP/inviteVIPApply.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "invitePaper",
        name: "invitePaper_en",
        component: () => import("../views/en/invitePaper.vue"),
        meta: {
          title:
            "Hardcopy invitation - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "invitePaperApply",
        name: "invitePaperApply_en",
        component: () => import("../views/en/invitePaperApply.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "onlineExpo",
        name: "onlineExpo_en",
        component: () => import("@/views/en/onlineExpo/onlineExpo.vue"),
        meta: {
          title:
            "Online Expo Settings - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "onlineExpoBanner1",
        name: "onlineExpoBanner1_en",
        component: () => import("@/views/en/onlineExpo/onlineExpoBanner1.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "onlineExpoBanner2",
        name: "onlineExpoBanner2_en",
        component: () => import("@/views/en/onlineExpo/onlineExpoBanner2.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "onlineExpoBanner3",
        name: "onlineExpoBanner3_en",
        component: () => import("@/views/en/onlineExpo/onlineExpoBanner3.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "onlineExpoBanner4",
        name: "onlineExpoBanner4_en",
        component: () => import("@/views/en/onlineExpo/onlineExpoBanner4.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "onlineExpoBooth",
        name: "onlineExpoBooth_en",
        component: () => import("@/views/en/onlineExpo/onlineExpoBooth.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "onlineExpoCardInfo",
        name: "onlineExpoCardInfo_en",
        component: () => import("@/views/en/onlineExpo/onlineExpoCardInfo.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },
      {
        path: "onlineExpoVideoList",
        name: "onlineExpoVideoList_en",
        component: () =>
          import("@/views/en/onlineExpo/onlineExpoVideoList.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "onlineVideoAdd",
        name: "onlineVideoAdd_en",
        component: () => import("@/views/en/onlineExpo/onlineVideoAdd.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "Boothevent",
        name: "Boothevent_en",
        component: () => import("../views/en/Boothevent/Boothevent.vue"),
        meta: {
          title: `Booth Event - Chan Chao Exhibitor's Online Service System`,
          requiresAuth: true,
        },
      },

      {
        path: "BootheventAdd",
        name: "BootheventAdd_en",
        component: () => import("../views/en/Boothevent/BootheventAdd.vue"),
        meta: {
          title: `Add Booth Event - Chan Chao Exhibitor's Online Service System`,
          requiresAuth: true,
        },
      },

      {
        path: "BootheventEdit",
        name: "BootheventEdit_en",
        component: () => import("../views/en/Boothevent/BootheventEdit.vue"),
        meta: {
          title: `Edit Booth Event  - Chan Chao Exhibitor's Online Service System`,
          requiresAuth: true,
        },
      },
      {
        path: "profile",
        name: "profile_en",
        component: () => import("@/views/en/profile.vue"),
        meta: {
          title: `Basic Information - Chan Chao Exhibitor's Online Service System`,
          requiresAuth: true,
        },
      },

      {
        path: "certificationApply",
        name: "certificationApply_en",
        component: () => import("@/views/en/certificationApply.vue"),
        meta: {
          title:
            "Certification Apply - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },
      {
        path: "upgrade",
        name: "upgrade_en",
        component: () => import("@/views/en/upgrade.vue"),
        meta: {
          title:
            "Additional Services Info. - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },
      {
        path: "upgradeEdm",
        name: "upgradeEdm_en",
        component: () => import("@/views/en/upgradeEdm.vue"),
        meta: {
          title:
            "Send e-Newsletter - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "chanchaoApp",
        name: "chanchaoApp_en",
        component: () => import("@/views/en/chanchaoApp.vue"),
        meta: {
          title: "ChanChao App - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "upgradeGetCard",
        name: "upgradeGetCard_en",
        component: () => import("@/views/en/upgradeGet/upgradeGetCard.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "upgradeGetList",
        name: "upgradeGetList_en",
        component: () => import("@/views/en/upgradeGet/upgradeGetList.vue"),
        meta: {
          title: "",
          requiresAuth: true,
        },
      },

      {
        path: "upgradeGetCardInfo",
        name: "upgradeGetCardInfo_en",
        component: () =>
          import("../views/en/upgradeGet/upgradeGetCardInfo.vue"),
        meta: {},
      },

      {
        path: "news",
        name: "news_en",
        component: () => import("@/views/en/News/news.vue"),
        meta: {
          title: "Press Release - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "newsAdd",
        name: "newsAdd_en",
        component: () => import("@/views/en/News/newsAdd.vue"),
        meta: {
          title: "Press Release - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "newsEdit",
        name: "newsEdit_en",
        component: () => import("@/views/en/News/newsEdit.vue"),
        meta: {
          title: "Press Release - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "product",
        name: "product_en",
        component: () => import("@/views/en/Product/product.vue"),
        meta: {
          title: "Products - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "productAdd",
        name: "productAdd_en",
        component: () => import("@/views/en/Product/productAdd.vue"),
        meta: {
          title: "Products - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "productEdit",
        name: "productEdit_en",
        component: () => import("@/views/en/Product/productEdit.vue"),
        meta: {
          title: "Products - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "productHistoryExh",
        name: "productHistoryExh_en",
        component: () => import("../views/en/Product/productHistoryExh.vue"),
        meta: {
          title:
            "Previous Exhibition List - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "productHistoryPro",
        name: "productHistoryPro_en",
        component: () => import("../views/en/Product/productHistoryPro.vue"),
        meta: {
          title: "Select Products - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "video",
        name: "video_en",
        component: () => import("@/views/en/Video/video.vue"),
        meta: {
          title: "Video - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "videoAdd",
        name: "videoAdd_en",
        component: () => import("@/views/en/Video/videoAdd.vue"),
        meta: {
          title: "Video - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "videoEdit",
        name: "videoEdit_en",
        component: () => import("@/views/en/Video/videoEdit.vue"),
        meta: {
          title: "Video - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "promotion",
        name: "promotion_en",
        component: () => import("../views/en/Promotion/promotion.vue"),
        meta: {
          title: "Promotion - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "promotionAdd",
        name: "promotionAdd_en",
        component: () => import("../views/en/Promotion/promotionAdd.vue"),
        meta: {
          title: "PromotionAdd - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "promotionSelectPro",
        name: "promotionSelectPro_en",
        component: () => import("../views/en/Promotion/promotionSelectPro.vue"),
        meta: {
          title:
            "PromotionSelectPro - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "promotionEdit",
        name: "promotionEdit_en",
        component: () => import("../views/en/Promotion/promotionEdit.vue"),
        meta: {
          title: "PromotionEdit - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "fascia",
        name: "fascia_en",
        component: () => import("../views/en/fascia.vue"),
        meta: {
          title: "Fascia Entry - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "Badge",
        name: "Badge_en",
        component: () => import("../views/en/Badge/Badge.vue"),
        meta: {
          title: "Badge - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },

      {
        path: "BadgeAdd",
        name: "BadgeAdd_en",
        component: () => import("../views/en/Badge/BadgeAdd.vue"),
        meta: {
          title: "BadgeAdd - Chan Chao Exhibitor Online Service System",
          requiresAuth: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/ExhibitorServiceTW/",
  routes,

  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default router;
